import { LoadManager } from 'managers/LoadManager'

const name = 'PRE-LOAD'

async function execute() {
  return LoadManager.init()
}

export function getPreLoadAction() {
  return {
    name,
    execute,
  }
}
